'use client';
import { useMemo } from 'react';
import { useSwanContext } from '../../contexts/swan-provider/swan-provider.context.js';
import { getSwanBaseUrl } from '../../../core/utilities/base-url.utils.js';
import { SWAN_BASE_CDN_URL } from '../../../core/constants/domains.js';

function useSwanHeadConfig(n, a, i, s) {
    let { swanBaseUrl: c, swanPathType: m, swanTenant: p, swanLocale: f } = useSwanContext();
    return useMemo(()=>{
        let r = c === SWAN_BASE_CDN_URL ? getSwanBaseUrl(i || p, s || f) : c;
        return {
            swanPathType: a || m,
            swanBaseUrl: n || r
        };
    }, [
        m,
        c,
        p,
        f,
        n,
        a,
        i,
        s
    ]);
}

export { useSwanHeadConfig };
